import ApiService from '@/common/api.service';

const url = '/v1/users';

const UserService = {
  query(filters) {
    let params = {};

    Object.keys(filters)
      .sort()
      .forEach(key => {
        params[key] = filters[key];
      });

    return ApiService.query(url, { params: params });
  },
  get(id) {
    return ApiService.get(url, id);
  },
  roles() {
    return ApiService.get('/v1/roles');
  },
  delete(id) {
    return ApiService.delete(`${url}/${id}`);
  },
  save(id = null, user) {
    if (!id) {
      return ApiService.post(url, user);
    }
    return ApiService.update(url, id, user);
  },
  search(param) {
    return ApiService.get(url, `search?filter[name]=${param}`);
  }
};

export default UserService;
